<template>
  <v-overlay :value="overlay" color="white" :opacity="opacity" :z-index="zIndex">
    <v-card flat tile elevation="0" color="transparent">
      <v-avatar tile width="100%">
        <v-icon size="96" color="error" x-large>mdi-alert</v-icon>
      </v-avatar>
      <v-card-title class="headline font-weight-bold error--text">{{ error.title }}</v-card-title>
      <v-card-subtitle class="error--text text-center">{{ error.message }}</v-card-subtitle>
      <v-card-action>
        <v-btn small block color="error" @click="errorCallback()">{{ error.action }}</v-btn>
      </v-card-action>
    </v-card>
  </v-overlay>
</template>

<script>
import { mapActions } from 'vuex';

const FORBIDDEN = 'forbidden', UNAUTHORIZED = 'unauthorized', AUTHENTICATION = 'authentication', INIT = 'init';

export default {
  name: 'ErrorPage',

  data: ()=> ({
    overlay: true,
    opacity: 0.95,
    zIndex: 300,

    errors: [
      { type: FORBIDDEN, title: 'ACCESSO NON CONSENTITO', message: 'Non disponi dei permessi per accedere all\'area', action: 'Torna alla Home', }, 
      { type: UNAUTHORIZED, title: 'NON AUTORIZZATO', message: 'Non disponi della licenza o dei ruoli necessari per accedere all\'applicazione', action: 'Esci dall\'applicazione', }, 
      { type: AUTHENTICATION, title: 'ACCESSO NON RIUSCITO', message: 'Si è verificato un errore nell\'accesso ai servizi', action: 'Esci', }, 
      { type: INIT, title: 'ATTENZIONE', message: 'Si è verificato un errore nella creazione dello spazio di lavoro', action: 'Esci', }
    ]
  }),

  computed: {
    error(){
      return this.errors.find((x)=> this.$route.params.type === x.type);
    }
  },

  methods: {
    ...mapActions('oidcStore', [ 'signOutOidc', 'removeOidcUser' ]),

    errorCallback(){
      switch(this.error.type){
        case INIT: this.signOutOidc(); break;
        case FORBIDDEN: this.$router.push('/calendar'); break;
        case UNAUTHORIZED: this.signOutOidc(); break;
        case AUTHENTICATION: this.signOutOidc(); break;
      }
    }
  }
}
</script>